var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowRightSecondary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2048 2048",
    style: {
      enableBackground: "new 0 0 2048 2048"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2C2E3E;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M925.9,1538.7c-50.3-50.4-100.3-100.3-150.3-150.3c120.7-120.7,241.6-241.5,362.4-362.3 C1016.8,904.8,895.9,784,775.4,663.5c50.5-50.5,100.5-100.5,150.7-150.7c170.4,170.8,341.2,342.1,511.5,512.9 C1267.5,1196.2,1096.7,1367.4,925.9,1538.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRightSecondary);
export default __webpack_public_path__ + "static/media/iconArrowRightSecondary.2761c734d25718ebd80c8bf009865272.svg";
export { ForwardRef as ReactComponent };